import * as types from "../constants/ComponentConstants";
import capitalize from "../util/stringFormatter";

export default {
	// initiële state bij het starten van de app.
	// Evt defaults in opnemen
	ajaxCounter: 0,
	exception: {
		exception: null,
		redirectToExceptionPage: false
	},
	security: {
		currentUser: {},
		currentApplication: '',
		currentOrganisation: '',
		organisations: [],
		roles: {},
		accountId: '',
		accountType: -1,
		error: ""
	},
	settings: {
		apiRoot: '', // root to the api site, including /api
		siteRoot: '', // root to the portal
		subsidiesWebAppRoot: '', // root to the parent subsidies app
		eloketUrl: '', // url to e-loket
		helpdeskContactLink: "",
		dagenNodigVoorMachtiging: 0,
		sportDBUrl: '',
		fileTypes: {},
		maxAllowedContentLength: "",
		disabled: false,
		maxMapFeaturesToLoad: 1500,
		osmBaseLayerUrl: "",
		bepijlingMarkerName: "",
		bevoorradingMarkerName: ""
	},
	validatieStatussen: [],
	layout: {
		pageHeaderTitle: "",
		pageHeaderSubtitle: "",
		svlDossierId: "",
		activeTopNavItemId: "1",
		showHeader: false,
		showTopNav: false,
		showBeads: false,
		scope: "e-loket",
		topNavTabsSet: false,
		topNavTabSettings: {
			organisatorTab: { text: "Organisator", color: types.COLOR_ORANGE, iconType: types.ICON_ORGANISATOR, disabled: false, visible: true, urlSuffix: "/organisator/" },
			veldtoertochtTab: { text: "Tocht", color: types.COLOR_TURQUOISE_DARK, iconType: types.ICON_VELDTOERTOCHT, disabled: false, visible: true, urlSuffix: "/veldtoertocht/" },
			lussenTab: { text: capitalize(types.AFSTANDEN_TEKST), color: types.COLOR_RED, iconType: types.ICON_AFSTANDEN, disabled: false, visible: true, urlSuffix: "/lussen/" },
			publicatieTab: { text: "Publicatie", color: types.COLOR_BLUE_DARK, iconType: types.ICON_PUBLICATIE, disabled: false, visible: true, urlSuffix: "/publicatie/" },
			toelatingenTab: { text: "Goedkeuringen", color: types.COLOR_GREEN, iconType: types.ICON_TOELATINGEN, disabled: false, visible: true, urlSuffix: "/goedkeuringen/" },
			samenvattingTab: { text: "Samenvatting", color: types.COLOR_PURPLE, iconType: types.ICON_SAMENVATTING, disabled: false, visible: true, urlSuffix: "/samenvatting/" },
			naarOverzichtTab: { text: "Terug naar overzicht", color: types.COLOR_PINK, iconType: types.ICON_TERUGNAAROVERZICHT, disabled: false, visible: true, urlSuffix: "" }
		},
		topNavPrefix: "",
		showSideNav: false,
		sideNavItems: [], // {id: "1", display: "SideNav Example 1", linkEnabled: true }
		sideNavPrefix: ""
	},
	referentie: {
		landen: [],
		gemeenten: [],
		postcodes: [],
		rechtspersoonlijkheidTypes: [],
		redenVanStatus: []
	}
};
